import { FontWeights, makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: 600,
    height: 600,
    overflow: 'hidden',
  },

  noScrollContainer: {
    overflow: 'hidden',
  },
}));
